export const USER_AUTH_KEY = '_stitch_ua';
export const REFRESH_TOKEN_KEY = '_stitch_rt';
export const DEVICE_ID_KEY = '_stitch_did';
export const STATE_KEY = '_stitch_state';
export const IMPERSONATION_ACTIVE_KEY = '_stitch_impers_active';
export const IMPERSONATION_USER_KEY = '_stitch_impers_user';
export const IMPERSONATION_REAL_USER_AUTH_KEY = '_stitch_impers_real_ua';
export const USER_AUTH_COOKIE_NAME = 'stitch_ua';
export const STITCH_ERROR_KEY = '_stitch_error';
export const STITCH_LINK_KEY = '_stitch_link';
export const DEFAULT_ACCESS_TOKEN_EXPIRE_WITHIN_SECS = 10;

export const APP_CLIENT_CODEC = {
  'accessToken': 'access_token',
  'refreshToken': 'refresh_token',
  'deviceId': 'device_id',
  'userId': 'user_id'
};

export  const ADMIN_CLIENT_CODEC = {
  'accessToken': 'access_token',
  'refreshToken': 'refresh_token',
  'deviceId': 'device_id',
  'userId': 'user_id'
};



// WEBPACK FOOTER //
// ./src/auth/common.js